import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'cookie-hint-box',
    templateUrl: './cookie-hint-box.component.html',
    styleUrls: ['./cookie-hint-box.component.scss']
})
export class CookieHintBoxComponent implements OnInit {
    private static readonly cookieName = 'CookieHint';

    @Input()
    public text: string;

    @Input()
    public privacyUrl: string;

    @Input()
    public privacyLinkText: string;

    @Input()
    public acceptButtonText: string;

    constructor() {
        console.log(this);
    }

    public ngOnInit(): void {

    }

    public cookieAccepted(): boolean {
        return !!this.getCookie(CookieHintBoxComponent.cookieName);
    }

    public hideCookieHint(): void {
        this.setCookie(CookieHintBoxComponent.cookieName, 'accepted');
    }

    private getCookie(name: string): string {
        const value = "; " + document.cookie;
        const parts = value.split("; " + name + "=");

        if (parts.length === 2) {
            return parts.pop().split(";").shift();
        }
    }

    private setCookie(name: string, value: string): void {
        // Set it
        document.cookie = name + "=" + value + "; path=/";
    }
}



// WEBPACK FOOTER //
// ./src/viega-common/components/cookie-hint-box/cookie-hint-box.component.ts